import api from '../api';

/**
 * Servicio API de las tarjetas del panel del empresario individual (renta de la persona).
 * Cada tarjeta es una fuente de datos con su tabla por año; ver
 * src/services/declaracionRenta/empresarioIndividual/tarjetas.js (servidor).
 */

const BASE_URL = '/api/declaracion-renta/ei';

const url = (idCompany, anioTributario, tarjeta) => `${BASE_URL}/${idCompany}/${anioTributario}/${tarjeta}`;

/**
 * Carga de la tarjeta: { estado: null | 'por_revisar' | 'validada', nombre_archivo, filas }
 */
export const getCargaTarjeta = async (idCompany, anioTributario, tarjeta) => {
  const response = await api.get(url(idCompany, anioTributario, tarjeta));
  return response.data;
};

/**
 * Sube el archivo de la tarjeta: el servidor lo lee y deja las filas «por revisar».
 * Responde 400 si el archivo no corresponde y 409 si ya hay una carga.
 */
export const subirArchivoTarjeta = async (idCompany, anioTributario, tarjeta, file) => {
  const formData = new FormData();
  formData.append('archivo', file);
  const response = await api.post(`${url(idCompany, anioTributario, tarjeta)}/archivo`, formData, {
    headers: { 'Content-Type': undefined }
  });
  return response.data;
};

export const validarCargaTarjeta = async (idCompany, anioTributario, tarjeta) => {
  const response = await api.post(`${url(idCompany, anioTributario, tarjeta)}/validar`);
  return response.data;
};

export const descartarCargaTarjeta = async (idCompany, anioTributario, tarjeta) => {
  const response = await api.delete(url(idCompany, anioTributario, tarjeta));
  return response.data;
};
